<template>
  <button
    :aria-label="title"
    class="chevron-btn h-8 w-8 md:h-12 md:w-12 flex-c rounded-full bg-white focus-a group"
  >
    <span
      :class="[ direction === 'next' ? 'rotate-270 mr-1 md:mr-2' : 'rotate-90 ml-1 md:ml-2' ]"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" v-bind:svg-inline="''" v-bind:class="'h-4 md:h-6 w-4 md:w-6 fill-current text-black'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M15.999 32L0 16.001h31.998z"/></svg>
    </span>
    <div
      class="chevron-btn__tooltip absolute px-5 py-2 bg-black hidden transition"
      :class="[ direction === 'next' ? 'right-16 right' : 'left-16 left', { 'group-hover:block': !touch } ]"
    >
      <span
        class="block text-white whitespace-no-wrap"
        v-html="title"
      />
    </div>
  </button>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'ChevronBtn',

  props: {
    title: {
      type: String,
      default: ''
    },
    direction: {
      type: String,
      default: 'next'
    }
  },

  computed: {
    ...mapState([ 'touch', 'mobile' ]),
    ...mapGetters([ ])
  }
}
</script>
